import { ITrackingAlert, AlertTrackParticipationStatusType } from '../domain/event/interface';
import Tooltip from 'antd/lib/tooltip';
import Tag from 'antd/lib/tag';
import { getComputerFormattedTime } from '../domain/date/date';
import { PRIMARY_COLOR, WARNING_COLOR, ERROR_COLOR, DISABLED_COLOR } from '../theme';

export const TrackingAlertStatusTag = ({ trackingAlert }: { trackingAlert: ITrackingAlert }) => {
    if (trackingAlert.participation_status === AlertTrackParticipationStatusType.CONFIRMED) {
        return (
            <Tooltip title={`Confirmed at ${getComputerFormattedTime(trackingAlert.participationUpdatedAt)}`}>
                <Tag color={PRIMARY_COLOR}>Confirmed</Tag>
            </Tooltip>
        );
    }

    if (trackingAlert.participation_status === AlertTrackParticipationStatusType.PARTIAL) {
        return (
            <Tooltip title={`Partially confirmed at ${getComputerFormattedTime(trackingAlert.participationUpdatedAt)}`}>
                <Tag color={WARNING_COLOR}>Partial</Tag>
            </Tooltip>
        );
    }

    if (trackingAlert.participation_status === AlertTrackParticipationStatusType.REJECTED) {
        return (
            <Tooltip title={`Declined at ${getComputerFormattedTime(trackingAlert.participationUpdatedAt)}`}>
                <Tag color={ERROR_COLOR}>Declined</Tag>
            </Tooltip>
        );
    }

    return <Tag color={DISABLED_COLOR}>No Response</Tag>;
};
